import axiosClient from './axiosClient';
import axios from 'axios';
const account = {
  get() {
    return axiosClient.get('/count');
  },
  async count() {
    const ipinfo = await axios.get(
      'https://ipinfo.io/json?token=94a9f02c6b89d6'
    );
    // console.log(ipinfo);
    return axiosClient.post('/count/insertCount', {
      ip: ipinfo.data.ip,
      finger: ipinfo.data.loc,
    });
  },
};

export default account;
